const houseModelConfig = {
  fontSize: 12,
  lineHeight: 1.3,
  colorGlobals: ["black", "black", "black", "black", "black"],
};

export default houseModelConfig;
